import { z } from 'zod';

export const userSchema = z.object({
  id: z.number(),
  name: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  email: z.email(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export type User = z.infer<typeof userSchema>;

export const timeZonesSchema = z.object({
  timezones: z.array(z.string()),
});
export type TimeZones = z.infer<typeof timeZonesSchema>;
